import { FETCh_AGENT_DETAILS_LOADING, FETCh_AGENT_DETAILS, FETCH_AGENT_DETAILS_FAILED } from "../actions/types";

const initialState = {
    isLoading: true,
    message: '',
    data: null,
};

export const AgentReducers = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case FETCh_AGENT_DETAILS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case FETCh_AGENT_DETAILS:
            return {
                ...state,
                isLoading: false,
                data: {
                    data: {
                        ...payload.data,
                        tempdata: payload?.data?.tempdata?.sort((a, b) => b.leads - a.leads),
                        totalLeads: payload?.data?.tempdata.reduce(function (sum, agent) {
                            return sum + parseInt(agent.leads);
                        }, 0),
                        totalSurveys: payload?.data?.tempdata.reduce(function (sum, agent) {
                            return sum + parseInt(agent.survey);
                        }, 0)
                    }
                }
            }
        case FETCH_AGENT_DETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                message: payload.message
            };
        default: return state;
    }
};
